




































import Vue from "vue";
import Spinner from "./Spinner.vue";
import CameraPreview from "./CameraPreview.vue";
import { Utils } from "@/js/Utils";
import { EventLogger } from "@/js/EventLogger";

const CAMERA_STRATEGIES = ["SwapInit_SwapResult", "SwapInit_KeepResult", "default", "KeepInit_SwapResult"];

export default Vue.extend({
  components: {
    CameraPreview,
    Spinner
  },
  data(): { currentTypeIndex: number; changing: boolean; autoRejectAttemps: number; errorStrategies: Array<string> } {
    return {
      currentTypeIndex: 0,
      changing: false,
      autoRejectAttemps: 0,
      errorStrategies: []
    };
  },
  computed: {
    currentType(): string {
      return CAMERA_STRATEGIES[this.currentTypeIndex];
    },
    autoSelecting(): boolean {
      return (
        Utils.getConfigBooleanValue("CAMERA_AUTO_SELECT_ENABLED") && this.autoRejectAttemps < CAMERA_STRATEGIES.length
      );
    }
  },
  methods: {
    onPermissionDeny() {
      this.$emit("no-permission");
    },
    async goNext() {
      this.changing = true;
      await this.waitUntilTestingStreamIsClosed();
      this.currentTypeIndex = this.findNextEligibleStrategyIndex();
      this.changing = false;
    },
    findNextEligibleStrategyIndex(): number {
      let nextIndex = this.currentTypeIndex + 1;
      while (this.errorStrategies.includes(CAMERA_STRATEGIES[nextIndex])) {
        nextIndex = nextIndex + 1;
      }
      return nextIndex % 4;
    },
    async confirm(auto: boolean) {
      const cameraPreview = this.$refs.cameraPreview as any;
      EventLogger.singleton.sendCameraSelectedEvent(cameraPreview.matchWithAllDimention, auto, this.currentType);
      this.changing = true;
      await this.waitUntilTestingStreamIsClosed();
      this.$emit("cameraSelected", this.currentType);
    },
    async waitUntilTestingStreamIsClosed() {
      const mediaStream = (window as any).testingStream as MediaStream;
      if (!mediaStream) return;
      await Utils.waitUntilCameraStreamIsClosed(mediaStream);
    },
    async onAutoConfirm() {
      await this.confirm(true);
    },
    async onAutoReject(hasError: boolean) {
      if (hasError) {
        this.errorStrategies.push(this.currentType);
        if (this.errorStrategies.length === CAMERA_STRATEGIES.length) {
          this.$emit("no-permission", true);
        }
      }
      this.autoRejectAttemps++;
      if (this.autoSelecting) {
        await this.goNext();
      }
    }
  }
});
